/** @file The two slot ids a direction-fix draw-order op names (swap a/b, moveAbove/moveBelow slot/ref). */
import type { DrawOrderOp } from './schemaParts/animation';

/** `[a, b]` of a swap, `[slot, ref]` of a move. */
export function drawOrderOpSlots(op: DrawOrderOp): [string, string] {
  return op.op === 'swap' ? [op.a, op.b] : [op.slot, op.ref];
}
